import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

interface LoadingProps {
  loading?: boolean
  fullScreen?: boolean
}

/**
 * Loading spinner
 * @param loading - whether it is shown
 */
export const Loading = ({ loading = true, fullScreen }: LoadingProps) => {
  if (!loading) return null
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: fullScreen ? '100vh' : '100%',
        position: fullScreen ? 'fixed' : 'relative',
        top: fullScreen ? 0 : undefined,
        left: fullScreen ? 0 : undefined,
        zIndex: fullScreen ? (theme) => theme.zIndex.modal : undefined,
      }}
    >
      <CircularProgress sx={{ m: 2 }} data-test-id="progress" />
    </Box>
  )
}
